import { ClipboardCheck, BookOpen, Car, Award, Check } from "lucide-react";
import { Reveal } from "../Reveal";
import { Stamp } from "../Stamp";

const steps = [
  { n: "01", icon: ClipboardCheck, title: "Înscriere", desc: "Ne suni sau ne scrii pe WhatsApp, aduci actele necesare și te înscrii în câteva minute." },
  { n: "02", icon: BookOpen, title: "Pregătire teoretică", desc: "Înveți legislația rutieră și pregătești examenul de sală cu materiale clare și suport constant." },
  { n: "03", icon: Car, title: "Ore practice", desc: "Conduci alături de instructorul tău, în ritmul potrivit, până capeți încredere la volan." },
  { n: "04", icon: Award, title: "Examen", desc: "Te prezinți pregătit la examenul de sală și de traseu. Te felicităm cu permisul în mână!" },
];

export const HowItWorks = () => (
  <section id="cum-functioneaza" data-testid="how-it-works-section" className="py-24 lg:py-36 bg-[#F8FAFC]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1565C0]">Traseul tău spre permis</p>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
          Cum funcționează, în 4 pași
        </h2>
      </Reveal>

      {/* Foaia de examen — procesul ca document de evaluare, ștampilat la final */}
      <Reveal delay={0.1}>
        <div className="relative mt-12 lg:mt-16 lg:ml-[8.333%] lg:mr-[8.333%] bg-white border border-slate-200 rounded-[28px] px-6 sm:px-10 lg:px-14">
          <div className="absolute inset-0 grain-overlay opacity-[0.06] pointer-events-none rounded-[28px]" />

          {/* perforații de arhivare — documentul e „de dosar" */}
          <span aria-hidden="true" className="absolute -left-3.5 top-24 w-7 h-7 rounded-full bg-[#F8FAFC] border border-slate-200 shadow-inner" />
          <span aria-hidden="true" className="absolute -left-3.5 bottom-28 w-7 h-7 rounded-full bg-[#F8FAFC] border border-slate-200 shadow-inner" />

          {/* dubla riglă — antet de document oficial */}
          <div aria-hidden="true" className="pt-7">
            <div className="border-t-[3px] border-slate-900" />
            <div className="mt-[3px] border-t border-slate-900" />
          </div>

          {/* rigla foii — linha de ghidaj, funcțională */}
          <div className="absolute left-[41px] sm:left-[57px] lg:left-[73px] top-[92px] bottom-[110px] w-[2px] guide-line-v" />

          {steps.map((s, i) => (
            <div key={s.n} data-testid={`step-${s.n}`} className="relative flex items-start gap-5 sm:gap-7 py-7 border-b border-slate-100">
              <span className="relative z-10 grid place-items-center w-9 h-9 rounded-full bg-white border-2 border-[#1565C0] text-[#1565C0] shrink-0 mt-0.5">
                <Check size={16} strokeWidth={3} />
              </span>
              <span className="font-display font-bold text-slate-300 text-lg w-8 shrink-0 mt-1.5">{s.n}</span>
              <div className="min-w-0">
                <h3 className="font-display font-semibold text-xl text-slate-900 flex items-center gap-3">
                  {s.title}
                  <s.icon size={18} className="text-[#1565C0]/50" />
                </h3>
                <p className="mt-1.5 text-slate-600 leading-relaxed text-[15px] max-w-lg">{s.desc}</p>
              </div>
            </div>
          ))}

          {/* concluzia documentului */}
          <div className="relative py-8 pr-28 sm:pr-36">
            <p className="font-display font-bold text-xl text-[#1565C0]">Felicitări — ai obținut permisul!</p>
            <p className="mt-1 text-slate-500 text-[15px]">Ești gata de drum, în siguranță.</p>
            <div aria-hidden="true" className="mt-4 h-px w-44 bg-slate-300" />
          </div>

          <Stamp ink="blue" className="absolute bottom-7 right-7 sm:right-10" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default HowItWorks;
